// extracted by mini-css-extract-plugin
export default {"rightPanelContainer":"RightPanelContainer-module__rightPanelContainer--PCXOe","animatedBackground":"RightPanelContainer-module__animatedBackground--0tl9E"};